import { TockenService } from './../../service/tocken.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../service/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private tockenService: TockenService , private authService: AuthService , private router: Router)   {
      this.tockenService.removeTocken();
      this.authService.changeAuthStatus(false);
      this.authService.setCurrentUser(null);
      this.router.navigateByUrl('/login');
  }

  ngOnInit(): void {
  }

}
